import { AxiosResponse } from 'axios';
// types
import { IPaginationParams } from 'src/types/pagination';
import { IUserChangePassParams, IUserUpdateParams } from 'src/types/user';
// global
import { ATTACHMENT_URL, CAPTCHA_API } from 'src/config-global';
//
import axios, { API_ENDPOINTS } from './axios';

type paginationProps = {
  skip: number;
  limit: number;
};

const responseBody = (response: AxiosResponse) => response?.data ?? null;

const requests = {
  get: (url: string, params?: any) => axios.get(url, params).then(responseBody),
  post: (url: string, body?: object | null, query?: Record<string, any>) =>
    axios
      .post(url, body ?? null, {
        params: query,
      })
      .then(responseBody),
  put: (url: string, body?: object | null, query?: Record<string, any>) =>
    axios
      .put(url, body ?? null, {
        params: query,
      })
      .then(responseBody),
  delete: (url: string, params?: any) => axios.delete(url, { params }).then(responseBody),
};

// ----------------------------------------------------------------------

const Statistics = {
  get: () =>
    axios
      .get(API_ENDPOINTS.statistics, {
        headers: {
          'x-api-key': 'arpoya@zharph',
        },
      })
      .then(responseBody),
};

const Account = {
  // getCaptcha: (id: string) => requests.get(API_ENDPOINTS.auth.get_captcha, { params: { id } }),
  getCaptcha: (id: string) =>
    requests.get(API_ENDPOINTS.auth.get_captcha, { baseURL: CAPTCHA_API, params: { id } }),
  checkCaptcha: (id: string, captchaKey: string, value: string) =>
    requests.post(API_ENDPOINTS.auth.check_captcha, { id, captchaKey, value }),
  checkCaptchaStatus: (captchaKey: string) =>
    requests.get(API_ENDPOINTS.auth.check_captcha_status, { params: { captchaKey } }),
  change_password: (params: IUserChangePassParams) =>
    requests.put(API_ENDPOINTS.user.change_password, params),
  update: (params: IUserUpdateParams, user_id: string) =>
    requests.post(API_ENDPOINTS.user.update.replace('{user_id}', user_id), params, { user_id }),
  getInviteLink: () => requests.get(API_ENDPOINTS.user.invite_link),
  getUsage: ({ fromDate, toDate }: { fromDate?: Date; toDate?: Date }) =>
    requests.get(API_ENDPOINTS.user.usage, {
      params: { from_date: fromDate, to_date: toDate },
    }),
};

const Notification = {
  list: ({ seen, skip, limit }: { seen?: string } & paginationProps) =>
    requests.get(API_ENDPOINTS.notifications.list, {
      params: {
        seen,
        skip,
        limit,
      },
    }),
  unSeenCount: () => requests.get(API_ENDPOINTS.notifications.unseen_count),
  seen: ({ notification_ids }: { notification_ids: string[] }) =>
    requests.post(API_ENDPOINTS.notifications.seen, {
      notification_ids,
    }),
  seenAll: () => requests.post(API_ENDPOINTS.notifications.seen_all),
};

const Session = {
  list: () => requests.get(API_ENDPOINTS.session.root),
};

const Payment = {
  calculate: (params: { token_amount: number }) =>
    requests.post(API_ENDPOINTS.payment.calculate, null, params),
  request: (params: { token_amount: number; description: string }) =>
    requests.post(API_ENDPOINTS.payment.request, params),
  getDiscounts: () => requests.get(API_ENDPOINTS.payment.discount),
  getTransactions: (params: IPaginationParams) =>
    requests.get(API_ENDPOINTS.payment.transactions, { params }),
  getTransaction: (id: string) => requests.get(`${API_ENDPOINTS.payment.transactions}/${id}`),
};

const Image = {
  getImage: (url: string) =>
    requests.get(url, {
      baseURL: ATTACHMENT_URL,
      responseType: 'blob',
    }),
};

const agent = {
  Statistics,
  Account,
  Notification,
  Session,
  Payment,
  Image,
};

export default agent;
